export default __webpack_public_path__ + "5dbf5642dd25e6610b84bc4e2cec1759.png";